import MenuBlocksList, { MenuBlocksListProps } from './MenuBlocksList';
import withInteractor from './MenuBlocksList.interactor';
import withPresenter from './MenuBlocksList.presenter';
  
export type { MenuBlocksListProps };
export default withInteractor(withPresenter(MenuBlocksList));
